/**
 * Test Cases API Service
 */

import { api } from './api';
import type { DashboardResponse } from '../types/api';

export const testCasesApi = {
  /**
   * Get dashboard data for authenticated tester.
   *
   * Multi-select filters (status, project, scenario) accept either a
   * single string or an array; arrays are joined with commas.
   */
  getDashboard: async (params?: {
    status?:
      | 'all'
      | 'new' | 'ongoing' | 'errors' | 'retest' | 'ready_to_validate' | 'closed'
      | Array<'new' | 'ongoing' | 'errors' | 'retest' | 'ready_to_validate' | 'closed'>;
    project?: string | string[];
    scenario?: string | string[];
    search?: string;
    userId?: string;
    page?: number;
    pageSize?: number;
    sort?: string;
    dueFilter?: 'all' | 'due' | 'overdue';
    view?: 'actionable' | 'all';
  }): Promise<DashboardResponse> => {
    const queryParams = new URLSearchParams();
    const appendMulti = (key: string, v: string | string[] | undefined) => {
      if (v == null) return;
      if (Array.isArray(v)) {
        for (const item of v) queryParams.append(key, item);
      } else {
        queryParams.set(key, v);
      }
    };

    appendMulti('status', params?.status as string | string[] | undefined);
    appendMulti('project', params?.project);
    appendMulti('scenario', params?.scenario);

    if (params?.search) queryParams.set('search', params.search);
    if (params?.userId) queryParams.set('user_id', params.userId);
    if (params?.page) queryParams.set('page', params.page.toString());
    if (params?.pageSize) queryParams.set('page_size', params.pageSize.toString());
    if (params?.sort && params.sort !== 'none') queryParams.set('sort', params.sort);
    if (params?.dueFilter && params.dueFilter !== 'all') queryParams.set('due_filter', params.dueFilter);
    if (params?.view) queryParams.set('view', params.view);

    const query = queryParams.toString();
    const endpoint = query ? `/tester/dashboard?${query}` : '/tester/dashboard';

    return api.get<DashboardResponse>(endpoint);
  },
};
